import React from 'react';
import PropTypes from 'prop-types';
import { FaAngleRight } from 'react-icons/fa';
import { FaCheck, FaUserClock, FaFileSignature } from 'react-icons/fa';
import { timestampToDateString } from '../../firebase';
import './review-selector.scss';

export const ReviewSelector = ({ label, reviews, showAuthor, onReviewClick }) => {

	const renderReview = (review) => {
		return <li key={`${review.id}_${review.album}`} id={`${review.id}_${review.album}`}>
		<button className={`link review-list-link`} onClick={() => {onReviewClick(review.id)}}>
			<FaAngleRight />
			{review.artist && review.album ? (
				<span className="review-album-artist">
					<span className="review-artist">{review.artist}</span> - <span className="review-album">{review.album}</span>
				</span>
			) : ''}
			{showAuthor && <span className="review-author"> {review.author} </span>}
			{review.reviewDate && <span className="review-date"> - {timestampToDateString(review.reviewDate)}</span>}
			<span className={`review-status ${review.status}`}>{renderStatus(review.status)}</span>
		</button>
		</li>
  }

	const renderReviews = () => {
		const listItems = reviews && reviews.map(review => renderReview(review));
		if (listItems.length) {
			return (
				<ul>
				{ listItems }
				</ul>
			);
		}
	}

	function renderStatus (status) {
		if (status === 'approved') {
			return <FaCheck title="Approved" />
		} else if (status === 'pending') {
			return <FaUserClock title="Pending Approval" />
		}
		return <FaFileSignature title="Draft" />
	}

	return (
		<div className="form-element review-selector">
			<h2>{label || 'Reviews'}</h2>
			<div className="list-wrap">
				{renderReviews()}
			</div>
		</div>
	)
};

ReviewSelector.propTypes = {
	label: PropTypes.string,
	reviews: PropTypes.array,
	showAuthor: PropTypes.bool,
	onReviewClick: PropTypes.func
}

export default ReviewSelector;
